import moment from "moment-timezone"

export const EVOLUTION_POLICY_MESSAGES = Object.freeze({
  invalidDate: "Data do atendimento inválida.",
  futureMonth: "Não é possível alterar parecer para datas posteriores ao mês atual.",
  retroactiveMonth: "Não é possível alterar parecer para datas de meses retroativos.",
})

export function normalizeRetroactiveEvolutionBlock(value) {
  return !(
    value === false
    || value === 0
    || value === "0"
    || String(value).toLowerCase() === "false"
  )
}

export function applyEmpresaEvolutionPolicyDefaults(empresa) {
  if (!empresa || typeof empresa !== "object") {
    return empresa
  }

  if (empresa.agenda_slot_duration_minutes == null || empresa.agenda_slot_duration_minutes === "") {
    empresa.agenda_slot_duration_minutes = 60
  }

  if (empresa.bloquear_evolucao_meses_retroativos == null || empresa.bloquear_evolucao_meses_retroativos === "") {
    empresa.bloquear_evolucao_meses_retroativos = true
  } else {
    empresa.bloquear_evolucao_meses_retroativos = normalizeRetroactiveEvolutionBlock(
      empresa.bloquear_evolucao_meses_retroativos
    )
  }

  return empresa
}

export function mergeEmpresaEvolutionPolicy(currentEmpresa, payload) {
  const empresa = {
    ...(currentEmpresa || {}),
  }

  if (payload && Object.prototype.hasOwnProperty.call(payload, "bloquear_evolucao_meses_retroativos")) {
    empresa.bloquear_evolucao_meses_retroativos = payload.bloquear_evolucao_meses_retroativos
  }

  return applyEmpresaEvolutionPolicyDefaults(empresa)
}

export function getEvolutionDateViolationMessage({ start, empresa, timezone }) {
  const startValue = String(start || "")
  const datePart = startValue.length >= 10 ? startValue.substring(0, 10) : ""

  if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    return EVOLUTION_POLICY_MESSAGES.invalidDate
  }

  const nowClinic = moment.tz(timezone)
  const monthStart = nowClinic.clone().startOf("month").format("YYYY-MM-DD")
  const monthEnd = nowClinic.clone().endOf("month").format("YYYY-MM-DD")
  const blockRetroactive = normalizeRetroactiveEvolutionBlock(
    empresa && Object.prototype.hasOwnProperty.call(empresa, "bloquear_evolucao_meses_retroativos")
      ? empresa.bloquear_evolucao_meses_retroativos
      : true
  )

  if (datePart > monthEnd) {
    return EVOLUTION_POLICY_MESSAGES.futureMonth
  }

  if (blockRetroactive && datePart < monthStart) {
    return EVOLUTION_POLICY_MESSAGES.retroactiveMonth
  }

  return null
}
